<template>
  <div>
    <div>
      <div class="table_outDiv yunfei-list">
        <div class="search_box">
          <el-button class="tiajia_btn" size="mini" @click="addYunFei">添加</el-button>
          <p>时间：</p>
          <el-date-picker
            size="mini"
            v-model="Time"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :time-arrow-control="true"
            value-format="yyyy/MM/dd HH:mm:ss"
          ></el-date-picker>
          <div style="margin-left:20px;">
            <el-input
              size="mini"
              clearable
              type="text"
              v-model="inputdata.str"
              placeholder="请输入模板名称"
            >
              <!-- <el-button size="mini" slot="append" icon="el-icon-search" @click="searchAction"></el-button> -->
              <span slot="append" @click="searchAction">搜索</span>
            </el-input>
          </div>
        </div>
        <div class="del-line">
          <el-button size="mini" @click="formsub">批量删除</el-button>
        </div>
        <el-table
          :data="YunList"
          style="width:100%"
          class="yufei-table"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column label="模板名称" width="150">
            <template slot-scope="scope">
              <p class="text-overflow">{{scope.row.name}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="city_names" label="运送到"></el-table-column>
          <el-table-column prop="start_num" label="首件（件）"></el-table-column>
          <el-table-column prop="start_money" label="首费（元）"></el-table-column>
          <el-table-column prop="plus_num" label="续件（件）"></el-table-column>
          <el-table-column prop="plus_money" label="续费（元）"></el-table-column>
          <el-table-column prop="update_time" label="修改时间" width="130"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <a @click="edit(scope.row)">修改</a>
              <a style="color:#999;margin-left:10px;" @click="del(scope.row.id)">删除</a>
            </template>
          </el-table-column>
        </el-table>
        <div
          v-if="YunList.length>0"
          style="text-align: center;margin-top: 20px;margin-bottom: 30px;"
        >
          <el-pagination
            @current-change="handleCurrentChange"
            prev-text="上一页"
            next-text="下一页"
            background=""
            layout="prev, pager, next"
            :total="total"
            :current-page="inputdata.page"
            :page-size="per_page"
          ></el-pagination>
        </div>
      </div>
      <el-dialog
        title="运费模板修改"
        :visible.sync="dialogVisible"
        width="600px"
        :before-close="handleClose"
      >
        <el-form :model="form" label-width="80px" ref="editForm" :rules="editRules">
          <el-form-item label="模板名称" prop="name">
            <el-input v-model="form.name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="运送到" prop="city_names">
            <el-input
              v-on:click.native="hideFormchengshi(form)"
              v-model="form.city_names"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="首件(件)" prop="start_num">
            <el-input v-model="form.start_num" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="首费(元)" prop="start_money">
            <el-input v-model="form.start_money" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="续件(件)" prop="plus_num">
            <el-input v-model="form.plus_num" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="续费(元)" prop="plus_money">
            <el-input v-model="form.plus_money" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="dialogVisible = false">取 消</el-button>
          <el-button size="small" type="primary" @click="sure">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog
        title="选择城市"
        :visible.sync="xuanzechengshi"
        :before-close="hideFormchengshi"
        width="800px"
      >
        <!-- 点击市的时候在这里添加按钮 -->
        <span>
          <table style="margin-top:1%;">
            <el-row style="float:left;" v-for="(item,index) in addshi" :key="index">
              <td>
                <el-button @click="unsershi(index);" type="primary" size="mini" round>{{item.value}}</el-button>
              </td>
            </el-row>
          </table>
        </span>
        <p style="margin-top:20px;">
          <b>全部省份</b>
        </p>
        <table style="margin-top:10px;width:679px;">
          <span
            v-for="item in province"
            :key="item.id"
            :label="item.value"
            :value="item.id"
            type="text"
          >
            <td style="width:50px;height:30px;margin-left:-10px;color:#409EFF;">
              <el-button size="small" @click="choseProvince(item.id)">{{item.value}}</el-button>
            </td>
          </span>
        </table>
        <p style="margin-top:20px;" v-if="shi1.length>0">
          <b>全部市</b>
        </p>
        <table style="margin-top:10px;" v-if="shi1.length>0">
          <span
            v-for="item in shi1"
            :key="item.id"
            :label="item.value"
            :value="item.id"
            @click="choseshi(item)"
            type="text"
          >
            <td style="width:50px;height:30px;margin-left:-10px;color:#409EFF;">
              <el-button size="small">{{item.value}}</el-button>
            </td>
          </span>
        </table>
        <el-button type="primary" size="mini" style="margin-top:30px" @click="quedingcurrcity">确定</el-button>
      </el-dialog>
    </div>
    <el-dialog title="选择城市" :visible.sync="yufeiVisible" width="1000px" top="50px">
      <YunFei ref="yufeiChild" @showYun="Fei"></YunFei>
    </el-dialog>
  </div>
</template>
<script>
import YunFei from "../components/YunFei";
import { getYunList, Yundel, getdata, formsub } from "../api/freight/freight";

export default {
  name:'YunFList',
  data() {
    return {
      yufeiVisible: false,
      YunList: [],
      total: 0, // 总页数
      per_page: 10,
      checkall: false,
      checked: [],
      multipleSelection: [],
      inputdata: {
        page: 1,
        str: ""
      },
      Time: "",
      dialogVisible: false,
      xuanzechengshi: false,
      form: {
        name: "",
        city_names: "",
        city_ids: "",
        start_num: "",
        start_money: "",
        plus_num: "",
        plus_money: ""
      },
      current_city_index: "",
      addshi: [
        {
          id: "52",
          value: "北京"
        }
      ],
      province: "",
      shi1: [],
      editRules: {
        name: [
          {
            required: true,
            message: "请填写模板名称",
            trgger: ["blur", "change"]
          }
        ],
        city_names: [
          {
            required: true,
            message: "请填写运送到的地址",
            trgger: ["blur", "change"]
          }
        ],
        start_num: [
          {
            required: true,
            message: "请填写首件件数",
            trgger: ["blur", "change"]
          }
        ],
        start_money: [
          {
            required: true,
            message: "请填写首件运费金额",
            trgger: ["blur", "change"]
          }
        ],
        plus_num: [
          {
            required: true,
            message: "请填写续件件数",
            trgger: ["blur", "change"]
          }
        ],
        plus_money: [
          {
            required: true,
            message: "请填写续件运费金额",
            trgger: ["blur", "change"]
          }
        ]
      }
    };
  },
  components: { YunFei },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    Fei(val) {
      if (val) {
        this.yufeiVisible = false;
        this.getYunLists();
      }
    },
    addYunFei() {
      this.yufeiVisible = true;
      this.$nextTick(() => {
        this.$refs.yufeiChild.getCityMessage();
      });
    },
    //隐藏选择城市
    hideFormchengshi(form) {
      this.xuanzechengshi = !this.xuanzechengshi;
      if (this.xuanzechengshi == true) {
        var city_ids = form.city_ids.split(","),
          city_names = form.city_names.split("-"),
          arr = [];
        city_ids.map((v, i) => {
          arr.push({
            id: v,
            value: city_names[i]
          });
        });
        this.addshi = arr;
      }
      this.shi1 = [];
    },
    edit(row) {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs["editForm"].resetFields();
        for (var key in row) {
          if (typeof row[key] == "number") {
            row[key] = row[key] + "";
          }
        }
        this.form = Object.assign({}, row);
      });
    },
    handleClose(done) {
      done();
    },
    sure() {
      this.$refs["editForm"].validate(valid => {
        if (valid) {
          let uid = this.$cookies.get("uid");
          let browser_token = this.$cookies.get("browser_token");
          let supplier_id = this.$cookies.get("supplier_id");
          formsub(this.form, uid, browser_token, supplier_id).then(response => {
            this.$message.success("修改成功");
            this.getYunLists();
            this.dialogVisible = false;
          });
        }
      });
    },
    //加载省市信息
    getCityMessage() {
      var that = this;
      getdata()
        .then(function(response) {
          if (response) {
            var data = response.data;
            that.province = [];
            that.city = [];
            that.block = [];
            for (var item in data) {
              if (
                data[item].region_type == 1 ||
                data[item].region_type == "1"
              ) {
                //省

                that.province.push({
                  id: data[item].city_id,
                  parent_id: data[item].parent_id,
                  value: data[item].city_name,
                  children: []
                });
              } else if (
                data[item].region_type == 2 ||
                data[item].region_type == "2"
              ) {
                //市
                that.city.push({
                  id: data[item].city_id,
                  parent_id: data[item].parent_id,
                  value: data[item].city_name,
                  children: []
                });
              } else {
                that.block.push({
                  id: data[item].city_id,
                  parent_id: data[item].parent_id,
                  value: data[item].city_name,
                  children: []
                });
              }
            }
            for (var index in that.province) {
              for (var index1 in that.city) {
                if (that.province[index].id === that.city[index1].parent_id) {
                  that.province[index].children.push(that.city[index1]);
                }
              }
            }
            for (var item1 in that.city) {
              for (var item2 in that.block) {
                if (that.city[item1].id === that.block[item2].parent_id) {
                  that.city[item1].children.push(that.block[item2]);
                }
              }
            }
          } else {
          }
        })
        .catch(err=>{
          console.error(err)
        });
    },
    // 选省
    choseProvince(e) {
      // this.provinceStap = e
      this.addshi = [];
      for (var index2 in this.province) {
        if (e === this.province[index2].id) {
          this.shi1 = this.province[index2].children;
          this.shi = this.province[index2].children[0].value;
          this.qu1 = this.province[index2].children[0].children;
          this.qu = this.province[index2].children[0].children[0].value;
          this.E = this.qu1[0].idp;
        }
      }
    },
    //选市
    choseshi(t) {
      var obj = {};
      obj.id = t.id;
      obj.value = t.value;
      for (var i in this.addshi) {
        if (this.addshi[i].id == obj.id) {
          return false;
        }
      }
      this.addshi.push(obj);
    },
    //删除市
    unsershi(f) {
      var w = confirm("确定删除吗？");
      if (w) {
        this.addshi.splice(f, 1);
      } else {
        return false;
      }
    },
    quedingcurrcity() {
      var regionidsmap = "";
      var regionnames = "";
      for (var item in this.addshi) {
        regionidsmap = regionidsmap + this.addshi[item].id + ",";
        regionnames = regionnames + this.addshi[item].value + "-";
      }
      regionidsmap = regionidsmap.substr(0, regionidsmap.length - 1);
      regionnames = regionnames.substr(0, regionnames.length - 1);
      this.form.city_names = regionnames;
      this.form.city_ids = regionidsmap;
      this.xuanzechengshi = !this.xuanzechengshi;
    },
    getYunLists(start_time, end_time) {
      var inputdata = this.inputdata;
      var uid = this.$cookies.get("uid");
      var token = this.$cookies.get("browser_token");
      var supplier_id = this.$cookies.get("supplier_id");
      getYunList(inputdata, start_time, end_time, uid, token, supplier_id).then(
        response => {
          this.loading = false;
          this.YunList = response.data.data.data || [];
          this.total = response.data.data.total;
        }
      );
    },
    formsub(v) {
      var param = [];
      if (v) {
        param.push(v);
      } else {
        for (var i = 0; i < this.multipleSelection.length; i++) {
          param.push(this.multipleSelection[i].id);
        }
      }
      if (param.length == 0) {
        this.$message.warning("请先选择要删除的模板");
        return;
      }
      Yundel(param).then(response => {
        this.loading = false;
        this.YunList = response.data.data.data || [];
        this.getYunLists();
      });
    },
    del(v) {
      let param = v;
      this.formsub(param);
    },
    searchAction() {
      this.inputdata.page = 1;

      if (!this.Time) {
        this.getYunLists("", "");
      } else {
        this.getYunLists(this.Time[0], this.Time[1]);
      }
    },
    handleCurrentChange(val) {
      this.inputdata.page = val;
      this.getYunLists();
    }
  },
  created() {
    this.getCityMessage();
    this.getYunLists();
  }
};
</script>
<style scoped>
thead {
  height: 50px;
}
.tit_top {
  line-height: 50px;
  padding-left: 30px;
}
.search_box {
  display: flex;
  align-items: center;
  padding: 10px;

  border-bottom: 1px solid #e6e6e6;
}
.search_box .inputs {
  width: 100px;
  height: 40px;
}
.btn-group {
  margin: 0 10px;
}
.btn-group button {
  height: 40px;
}
.lahei {
  background: #fff;
  border: none;
  outline: none;
  color: #ff6b56;
}
thead th {
  text-align: center;
}
tr td {
  text-align: center;
}
tr td p {
  color: #333;
}
tr td:last-child span {
  display: inline-block;
  margin-left: 10px;
}
tr td:last-child a {
  color: #ff6b56;
}
tr td input {
  width: 20px;
  height: 20px;
  cursor: pointer;
}
.tiajia_btn {
  color: #fff;
  background: linear-gradient(to right, #fd314a, #ffd778);
  margin-right: 20px;
  border: 0;
}
.quanxuan_tr td:nth-child(2) {
  text-align: left;
}
.quanxuan_tr td span {
  margin: 0 20px;
}
/* 页码 */
.pagination > li {
  display: inline-block;
  margin: 5px;
}

/* .table > thead > tr > th,
.table > tbody > tr > td {
  vertical-align: middle;
  text-align: center;
} */
.del-line {
  line-height: 50px;
  padding: 0 30px;
  /* border-bottom:1px solid #e6e6e6; */
}
</style>
<style>
.yufei-table {
  width: 100%;
  font-size: 12px !important;
  border-top: 1px solid #e6e6e6;
}
.yufei-table tr td,
.yufei-table tr th {
  text-align: center;
  padding: 5px 2px;
}
.yufei-table tr td .cell {
  padding: 0;
  color: #555 !important;
}
.yunfei-list .el-button {
  outline: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/YunFList.vue